export default function ReportPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-slate-900 mb-2">
          Assessment Report
        </h1>
        <p className="text-lg text-slate-600 mb-8">
          Azure/M365 Maturity Assessment Results
        </p>

        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">
              Overall Maturity Tier
            </h2>
            <div className="text-6xl font-bold text-blue-600 mb-2">—</div>
            <p className="text-slate-600">
              Overall score pending assessment completion
            </p>
          </div>

          <div className="border-t pt-8">
            <h3 className="text-xl font-semibold text-slate-800 mb-6">
              Domain Scores
            </h3>
            <div className="space-y-4">
              {[
                'Identity & Access Management',
                'Data Protection',
                'Endpoint Security',
                'Network Security',
                'Threat Management'
              ].map(domain => (
                <div key={domain} className="flex items-center justify-between">
                  <span className="font-medium text-slate-700">{domain}</span>
                  <div className="flex-1 mx-4 bg-slate-200 h-3 rounded-full"></div>
                  <span className="text-sm text-slate-500">Pending</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors">
          Back to Dashboard
        </button>
      </div>
    </div>
  )
}
